// extracted by mini-css-extract-plugin
module.exports = {"axisTitle":"AxisTitle_axisTitle__2qE5E"};